module.exports.sites = {
  com: {
    baseUrl: process.env.SITE_COM_BASE_URL,
  },
  rh: {
    baseUrl: process.env.SITE_RH_BASE_URL,
  },
  blog: {
    baseUrl: process.env.SITE_BLOG_BASE_URL,
  },
  gc: {
    baseUrl: process.env.SITE_GC_BASE_URL,
  },
  sl: {
    baseUrl: process.env.SITE_SL_BASE_URL,
  },
  lp: {
    baseUrl: process.env.SITE_LP_BASE_URL,
  },
  grp: {
    baseUrl: process.env.SITE_GRP_BASE_URL,
  },
}
